import { useNpr } from '@stores';
import { useEffect } from 'react';
import { connect } from 'redux-bundler-react';
import { getEnvironmentVisibility } from '@components/environment-visibility/EnvironmentVisibility';

// Only show in local environment
const displayOutcome = getEnvironmentVisibility({ mode: 'show', local: true });

const NprSuggest = connect('doUpdateNprRequest', ({ nprResult, doUpdateNprRequest }) => {
  const { setNprResult } = useNpr();

  useEffect(() => {
    doUpdateNprRequest({ nprResult });
    setNprResult(nprResult);
  }, [doUpdateNprRequest, nprResult, setNprResult]);

  return displayOutcome && nprResult ? (
    <div className='margin-top-1 text-italic'>
      outcome: <div className='text-bold'>{nprResult}</div>
    </div>
  ) : null;
});
export default NprSuggest;
